import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import TeamService from '../../../apis/teamservice';
import { inhouseLogin, sendLoginDataToCrisp, userLogin, userLogout } from '../../../apis/pvlapis';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { setAccessTokenCookie, setRefreshToken, setUserDetails } from '../../../apis/tokenhandler';
import { Mixpanel } from '../../../configs/mixPanel';

const CreateUserAccountModal = ({showModal,setShowModal,userId, loginUsername, loginPwd, loginAccessToken, source}) => {
    // When user is not part of any account
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [disableCreateAccountButton, setDisableCreateAccountButton] = useState(false);

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const handleOnSignoutClick = async() =>{
        await userLogout();
        setShowModal(false);
        sleep(100);
        navigate("/");
    }

  const handleOnCreateAccoutClick = async() =>{
    try {
        setDisableCreateAccountButton(true);
        setIsLoading(true);
        const response = await TeamService.CreateUserAccount(navigate,userId);
        if(response?.data?.statusCode === 200){
          toast.success("New Account Created.",{position:toast.POSITION.BOTTOM_LEFT});
          if(source === 'inhouse'){
            const requestForm = {
              "userEmail": loginUsername,
              "password": loginPwd
            }
            //Hit the inhouse login endpoint
            const response = await inhouseLogin(requestForm);
            if (response.data.statusCode === 200){
              //Set the access and refresh tokens
              setAccessTokenCookie(response.data.result.tokens.accessToken);
              setRefreshToken(response.data.result.tokens.refreshToken);
              const userDetails = response.data.result.userDetails;
              const userDetailsString = JSON.stringify(userDetails);
              setUserDetails(userDetailsString);
              // console.log(response.data.result.userDetails.userid);
              Mixpanel.identify(userDetails.userid);
              Mixpanel.people.set({
                "$name": userDetails.userfullname,
                "$email": userDetails.useremail,
                "Account": userDetails.accountid
              })
              sendLoginDataToCrisp(userDetails);
              navigate('/home');
            }
            else{
                toast.error("Something went wrong. Please try again.",{position: toast.POSITION.BOTTOM_LEFT});
            }
          }
          else{
            await userLogin(loginAccessToken, source, navigate,'');

          }
        }
    } catch (error) {
        toast.error(`Something went wrong. Please try again after some time.`,{position: toast.POSITION.BOTTOM_LEFT});
    }
    finally{
      setShowModal(false);
      setDisableCreateAccountButton(false);
      setIsLoading(false);
    }  
  }

  

  return (
    <Modal
      show={showModal}
      size="sg"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={handleOnSignoutClick}
      // centered
      className='modal-no-border'
    >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
            <div className="verify-fail">
                <div className="text-center mb-3">
                <img src={require("../../../../assets/img/alert.svg").default} alt="Failed" />
                </div>
                
                <div className="text-center font-18 dark-text poppins-semibold mb-2">
                No account found!
                </div>
                <p className="text-center font-14 grey-text mw-388 pt-1 poppins-regular">
                You are not part of any account. Please create a new account to start using SureConnect
                </p>
                {/* <div className="text-center mt-3">
                    <button className="btn blue-btn-primary font-12 position-relative btn btn-primary" >
                    Create account</button>
                </div> */}
            </div>
        </Modal.Body>
        <Modal.Footer  className="no-shadow pt-0">
          <div className="text-end w-100">
              <Button className="btn btn-cancel mr-15px" variant="secondary" onClick={handleOnSignoutClick}>
                  Cancel
              </Button>
              <Button className="btn blue-btn-primary font-12 small-btn position-relative" variant="primary" onClick={handleOnCreateAccoutClick} disabled={disableCreateAccountButton} >
                Create account
                {isLoading&&<div className="spinner-border position-absolute spinner" role="status" >
                          <span className="visually-hidden">Loading...</span>
                      </div>}
              </Button>
          </div>
        </Modal.Footer>
    </Modal>      
  )
}

export default CreateUserAccountModal